import { i18nData } from 'helpers/i18n'
import MarkdownScript from 'helpers/markdownScript';

import markdownFile from './index.md';
import markdownFile_fr_CA from './index.fr_CA.md';

export default i18nData({
  en: new MarkdownScript(markdownFile),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});



// WEBPACK FOOTER //
// ./programs/h2whoa/md.js